import React from 'react'
import { RichText, XP_REQUEST_MODE, type ComponentProps, type ExtendedRichTextData, type PartData } from '@enonic/react-components'
import TextBlockPrototype from './prototype/TextBlock'

type TextBlockRow = {
	heading?: string
	headingOnSide?: boolean
	body?: ExtendedRichTextData
}

type TextBlockPartData = {
	blocks?: TextBlockRow[]
}

export const TextBlock = ({ component, meta, data, common }: ComponentProps<PartData>) => {
	const { blocks = [] } = (data || {}) as TextBlockPartData

	if (blocks.length === 0) {
		return meta?.mode === XP_REQUEST_MODE.EDIT ? <section className="text-block text-block--empty" /> : <></>
	}

	return (
		<TextBlockPrototype
			items={blocks.map(({ heading = '', headingOnSide, body }) => ({
				title: heading,
				text: body && <RichText tag="div" data={body} component={component} meta={meta} common={common} />,
				isHeadingSided: headingOnSide,
			}))}
		/>
	)
}
